'use strict';

import { Entity } from '../Entity';
import { GlobCountyZipCollection } from '../../Collections/Glob/GlobCountyZipCollection';

export class GlobCountyZip extends Entity {
  protected id;
  protected state;
  protected county;
  protected fips;
  protected zip;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;
    this.state = data.state;
    this.county = data.county;
    this.fips = data.fips;
    this.zip = data.zip;
  }

  public getId() {
    return this.id;
  }

  public getState() {
    return this.state;
  }

  public getCounty() {
    return this.county;
  }

  public getFips() {
    return this.fips;
  }

  public getZip() {
    return this.zip;
  }
}
